export default "__VITE_ASSET__C17S_bz3__"